import { render, staticRenderFns } from "./hitchRideOrderDispatch.vue?vue&type=template&id=79b161fe&scoped=true"
import script from "./hitchRideOrderDispatch.vue?vue&type=script&lang=js"
export * from "./hitchRideOrderDispatch.vue?vue&type=script&lang=js"
import style0 from "./hitchRideOrderDispatch.vue?vue&type=style&index=0&id=79b161fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b161fe",
  null
  
)

export default component.exports